// extracted by mini-css-extract-plugin
export var aircallIframe = "_j4-3";
export var fabContainer = "_j4-5";
export var fabRinging = "_j4-6";
export var loadingOverlay = "_j4-4";
export var pulse = "_j4-7";
export var widgetContent = "_j4-2";
export var widgetPanel = "_j4-0";
export var widgetPanelExpanded = "_j4-1";